import { ApiRole } from '@ibe/api';
import Agency from './Agency';
import User from './User';

class AuthState {
  user: User | null;

  firstName: string | null;

  lastName: string | null;

  agency: Agency | null;

  role: ApiRole | null;

  token: string | null;

  get isAgency(): boolean {
    return !!this.agency;
  }

  get isLoggedIn(): boolean {
    return !!this.user && !this.isGuest;
  }

  get isGuest(): boolean {
    return this.role === ApiRole.GUEST;
  }
}

export default AuthState;
